var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"mobile-header flex--space-between--center"},[_vm._t("header"),_c('div',{staticClass:"icon-close custom-icon ml10",on:{"click":_vm.onCloseButtonClick}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }